export const UPDATE_SECURITY_QUESTION_ACTION = "password-reset/UPDATE_SECURITY_QUESTION_ACTION";

export default function updateSecurityQuestionAction() {
  return {
    "payload": {},
    "type": UPDATE_SECURITY_QUESTION_ACTION
  };
}
